import { render } from "./Location.vue?vue&type=template&id=1af1a059&scoped=true"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"

import "./Location.vue?vue&type=style&index=0&id=1af1a059&lang=scss&scoped=true"
import "./Location.vue?vue&type=style&index=1&id=1af1a059&lang=css"
script.render = render
script.__scopeId = "data-v-1af1a059"

export default script